export default "/_next/static/chunks/fonts/Channel4Chadwick-Medium-3f0a6039d3613eb1308de2fa8ac603c5.woff2";